import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Loader from '../../components/common/Spinners/Loader'
import ServiceCard from './ServiceCard';
import MyOrdersAndSupportCenter from "./MyOrdersAndSupportCenter";
import moment from 'moment';
import ManagePlan from "./ManagePlan";
import isEmpty, { formatAmount } from "../../utils/helpers";
import FlyInRightPanel from '../../components/FlyInRightPanel'
import Invoices from './Invoices'
import Payment from './Payment'
import ProgressBar from "../../components/ProgressBar";
import AutoPay from './AutoPay';
import Paperless from "./Paperless";

const PANEL = {
    NONE: 0,
    INVOICES: 1,
    MANAGE_PLANS: 2,
    PAYMENT: 3,
    AUTOPAY: 4,
    PAPERLESS: 5,
    ORDERS: 6,
}

export const DISTRIBUTION_METHOD = {
    EMAIL: 'EMAIL',
    PAPERLESS: 'PAPERLESS',
    PAPER: 'PAPER',
}

export const DISTRIBUTION_METHOD_DESCRIPTION = {
    EMAIL: 'Paperless is enabled, you will receive an email with invoice attached.',
    PAPER: 'Paperless is disabled, you will receive a paper invoice.',
    PAPERLESS: 'Paperless is enabled, you will receive an email notifying you that your invoice is available in the customer portal.'
}

export const DISTRIBUTION_METHOD_DESCRIPTION_SHORT = {
    EMAIL: 'Receive an email with invoice attached.',
    PAPER: 'Receive a paper invoice.',
    PAPERLESS: 'Receive an email notifying you that your invoice is available in the customer portal.'
}

const callFunc = (func, ...args) => {
    if (typeof func === 'function') {
        func(...args);
    }
}

export class CustomerServices extends Component {

    state = {
        showManagePlanIndex: -1,
        activePanel: PANEL.NONE,
        visiblePanel: PANEL.NONE,
        resetFormOnClose: false,
        preventPanelClosing: false,
    }

    static propTypes = {
        accountInfo: PropTypes.object.isRequired
    };

    showPanel = (panel, getInitialSate) => {
        this.setState(prevState => {
            const additionalState = callFunc(getInitialSate, prevState);
            return { activePanel: panel, ...additionalState };
        },
            () => {
                clearTimeout(this.panelTimeoutHandler);
                this.panelTimeoutHandler = setTimeout(() => this.setState({ visiblePanel: panel }), 0)
            }
        );
    }

    hidePanel = (hideTimeoutMs, callback) => {
        this.setState({ visiblePanel: PANEL.NONE }, () => {
            callFunc(callback);
            clearTimeout(this.panelTimeoutHandler);
            this.panelTimeoutHandler = setTimeout(() => this.setState({ activePanel: PANEL.NONE }), hideTimeoutMs || 500);
        });
    }

    togglePanel = (panel, hideTimeoutMs, getInitialSate, onHideCallback) => {
        if (this.state.activePanel === panel) {
            this.hidePanel(hideTimeoutMs, onHideCallback);
        } else {
            this.showPanel(panel, getInitialSate);
        }
        // Reset form
        this.setState({ resetFormOnClose: true }, () => {
            this.setState({ resetFormOnClose: false });
        })
    }

    showHideManagePlan = (index) => {
        this.togglePanel(
            PANEL.MANAGE_PLANS,
            500,
            () => this.setState({ showManagePlanIndex: index }),
            () => this.setState({ showManagePlanIndex: -1 })
        );
    }

    togglePreventPanelClosing = (state) => {
        this.setState({preventPanelClosing: state});
    }

    componentDidUpdate() {

        // Lock / unlock body scrolling
        setTimeout(() => {
            if (this.state.activePanel !== PANEL.NONE)
                document.body.classList.add('sidebar-open')
            else
                document.body.classList.remove('sidebar-open')
        }, 0);
    }

    componentWillUnmount() {
        clearTimeout(this.panelTimeoutHandler);

        // Unlock body scrolling
        document.body.classList.remove('sidebar-open')
    }

    presentServiceCards = () => {
        const { visiblePanel, showManagePlanIndex } = this.state;
        const { myServiceInfo, accountInfo } = this.props;

        if (isEmpty(myServiceInfo)) {
            return null;
        }

        const elements = [];

        for (let index = 0; index < myServiceInfo.length; index++) {

            const service = myServiceInfo[index];

            const curElement = (
                <ServiceCard showHideManagePlan={this.showHideManagePlan}
                    myServiceInfoItem={service} myServiceInfoItemIndex={index} {...this.props} />
            );

            const nextService = (index + 1) < myServiceInfo.length ? myServiceInfo[index + 1] : null;

            const nextElement = !isEmpty(nextService)
            ?
                <ServiceCard
                    showHideManagePlan={this.showHideManagePlan}
                    myServiceInfoItem={nextService}
                    myServiceInfoItemIndex={index + 1}
                    {...this.props}
                />
            :
                null;

            elements.push(
                <Fragment>
                    {curElement}
                    {nextElement}
                </Fragment>
            );

            index++;

            if (showManagePlanIndex >= 0 && (showManagePlanIndex === index || showManagePlanIndex === index - 1)) {

                elements.push(
                    <FlyInRightPanel
                        title={myServiceInfo[showManagePlanIndex].planDescription}
                        isVissible={visiblePanel === PANEL.MANAGE_PLANS}
                        onClose={() => this.showHideManagePlan(showManagePlanIndex)}
                    >
                        <ManagePlan myServiceInfoItemIndex={(showManagePlanIndex)}
                            planName={myServiceInfo[showManagePlanIndex].planName}
                            showHideManagePlan={() => this.showHideManagePlan(showManagePlanIndex)}
                            myServiceInfoItem={myServiceInfo[showManagePlanIndex]} {...this.props}
                            {...this.props}
                        />
                    </FlyInRightPanel>
                );

                // Lock body scrolling
                document.body.classList.add('sidebar-open');

            } else {

                // Unlock body scrolling
                document.body.classList.remove('sidebar-open');
            }

        }

        return (
            <Fragment>
                {elements}
            </Fragment>
        );
    }

    render() {

        const {
            activePanel,
            visiblePanel,
            resetFormOnClose,
            preventPanelClosing,
        } = this.state;

        const {
            accountInfo,
            myServiceInfoLoader,
            myOrdersInfoLoader,
            myInvoicesInfoLoader,
            myOrders,
            myInvoices,
            myAmounts,
            myAmountsLoader,
            myAutoPayInfo,
            myAutoPayAvailableCC,
            myDistributionMethods,
        } = this.props;

        const myCurrentDistributionMethod = this.props.myCurrentDistributionMethod && this.props.myCurrentDistributionMethod.length
            ? this.props.myCurrentDistributionMethod[0]
            : {};

        if (myServiceInfoLoader) {
            return <Loader />
        }

        let billCyclePercents = 0;
        let daysLeftOfBillCycle = 0;

        if (accountInfo.billCycle) {
            const now = moment();
            const billCycleStart = moment().date(accountInfo.billCycle);
            let billCycleEnd = moment(billCycleStart).add(1, 'month');
            const totalPeriod = billCycleEnd.diff(billCycleStart, 'days');

            if (billCycleStart.diff(now, 'days') === 0) {
                billCycleEnd = moment();
            }

            const fromStartPeriod = billCycleEnd.diff(moment(), 'days');
            billCyclePercents = ((totalPeriod - fromStartPeriod) / totalPeriod) * 100;
            daysLeftOfBillCycle = billCycleEnd.diff(now, 'days');

            if (billCyclePercents === 0) {
                billCyclePercents = 1;
            }
        }

        return (
            <>
                <div className="container-customer-services">
                    <div className="container">

                        <div className="container-customer">
                            <div className="row">
                                <div className="cp-col col-sm-7">
                                    <h3>
                                        <span className="font-weight-light">Welcome,</span>{' '}
                                        {accountInfo && accountInfo.primaryContact && !isEmpty(accountInfo.primaryContact.company)
                                            ? accountInfo.primaryContact.company
                                            : accountInfo.primaryContact.firstName
                                        }
                                    </h3>
                                    <p>Account #: {accountInfo.number}</p>
                                </div>
                                <div className="cp-col col-sm-5 d-flex align-items-center justify-content-start justify-content-sm-end">
                                    <button
                                        className="btn btn-secondary" data-target="default"
                                        onClick={() => this.togglePanel(PANEL.PAYMENT)}
                                    >
                                        Make a Payment
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="row">

                            {accountInfo.status !== 'Survey' && accountInfo.status !== 'Signup' && (
                                <div className="cp-col col-12 col-lg-6 d-flex">
                                    <div className="card card-service">

                                        <div className="card-caption">
                                            <div className="card-left">

                                                <div className="card-icon">
                                                    <i className="fas fa-wallet" />
                                                </div>

                                            </div>
                                            <div className="card-right">

                                                <div className="card-header">
                                                    Total balance
                                                    <span className="font-weight-bold float-right">
                                                        {myAmountsLoader &&
                                                            <i className="fas fa-spinner fa-spin" />}
                                                        {!myAmountsLoader && myAmounts &&
                                                            '$' + formatAmount(myAmounts.accountBalace)}
                                                    </span>
                                                </div>

                                                <div className="card-description">
                                                    Check your bills and make a payment.
                                                </div>

                                            </div>
                                        </div>

                                        <div className="card-body">

                                            {accountInfo.billCycle && (
                                                <ProgressBar
                                                    icon={'far fa-fw fa-clock'}
                                                    title={'Bill Cycle'}
                                                    value={daysLeftOfBillCycle + (daysLeftOfBillCycle === 1 ? ' Day' : ' Days') + ' left'}
                                                    color={'red'}
                                                    percentage={billCyclePercents}
                                                    note={''}
                                                />
                                            )}

                                            <div className="list">

                                                {((myDistributionMethods && myDistributionMethods.length > 0) || myCurrentDistributionMethod) &&
                                                <p className="border-bottom">
                                                    <span>
                                                        <i className="far fa-fw fa-file-alt mr-1 text-danger"/>
                                                        {myCurrentDistributionMethod &&
                                                            DISTRIBUTION_METHOD_DESCRIPTION[myCurrentDistributionMethod.name && myCurrentDistributionMethod.name .toUpperCase()]
                                                        }
                                                    </span>
                                                    {(myDistributionMethods && myDistributionMethods.length > 0) &&
                                                    <button
                                                        className="btn btn-quick float-right" type="button"
                                                        onClick={() => this.togglePanel(PANEL.PAPERLESS)}
                                                    >
                                                        <i className="fas fa-cog"/>
                                                    </button>
                                                    }
                                                </p>
                                                }

                                                <p>
                                                    <span>
                                                    {myAutoPayInfo && (myAutoPayInfo.apiAccountAutoPayACH || myAutoPayInfo.apiAccountAutoPayCC)
                                                        ? <>
                                                            <i className="far fa-fw fa-check-circle mr-1 text-success" />
                                                            Active. AutoPay applies on {myAutoPayInfo.appliesOn}
                                                        </> : <>
                                                            <i className="far fa-fw fa-times-circle mr-1" />
                                                            AutoPay is Inactive.
                                                        </>
                                                    }
                                                    </span>
                                                    <button
                                                        className="btn btn-quick float-right" type="button"
                                                        onClick={() => this.togglePanel(PANEL.AUTOPAY)}
                                                    >
                                                        <i className="fas fa-cog" />
                                                    </button>
                                                </p>

                                            </div>

                                            {myAutoPayInfo && myAutoPayInfo.apiAccountAutoPayCC && <>
                                                <ProgressBar
                                                    icon="far fa-fw fa-credit-card mr-1"
                                                    title="Card Number"
                                                    value={myAutoPayInfo.apiAccountAutoPayCC.displayCardNumber}
                                                />
                                                <ProgressBar
                                                    icon="far fa-fw fa-hourglass mr-1"
                                                    title="Expiration Date"
                                                    value={myAutoPayInfo.apiAccountAutoPayCC.cardExpirationDate}
                                                />
                                            </>}

                                            {myAutoPayInfo && myAutoPayInfo.apiAccountAutoPayACH && <>
                                                <ProgressBar
                                                    icon="fas fa-fw fa-hashtag mr-1"
                                                    title="Routing Number"
                                                    value={myAutoPayInfo.apiAccountAutoPayACH.routing_number}
                                                />
                                                <ProgressBar
                                                    icon="fas fa-fw fa-hashtag mr-1"
                                                    title="Bank Account"
                                                    value={myAutoPayInfo.apiAccountAutoPayACH.account_number}
                                                />
                                            </>}

                                        </div>

                                        <div className="card-footer">
                                            <div className="card-footer-toolbar">

                                                <button className="btn btn-sm btn-fw-enable btn-light" data-target="view-bill"
                                                    onClick={() => this.togglePanel(PANEL.INVOICES)}>
                                                    View Invoices
                                                </button>

                                                <button className="btn btn-sm btn-fw-enable btn-primary" data-target="default"
                                                    onClick={() => this.togglePanel(PANEL.PAYMENT)}>
                                                    Make a Payment
                                                </button>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )}

                            {this.presentServiceCards()}

                            {!myOrdersInfoLoader && <MyOrdersAndSupportCenter myOrders={myOrders} myOrdersInfoLoader={myOrdersInfoLoader} hasActivePanel={activePanel !== PANEL.NONE} />}
                            {myOrdersInfoLoader && <MyOrdersAndSupportCenter myOrders={myOrders} myOrdersInfoLoader={myOrdersInfoLoader} hasActivePanel={activePanel !== PANEL.NONE} />}

                        </div>


                        {accountInfo.status !== 'Survey' && accountInfo.status !== 'Signup' && (
                            <>

                                {/* Payment Panel needs to be kept in the DOM, so IPPay requests can complete normally */}
                                {/*{activePanel === PANEL.PAYMENT &&*/}
                                <FlyInRightPanel
                                    title="Payment"
                                    isVissible={visiblePanel === PANEL.PAYMENT}
                                    preventPanelClosing={preventPanelClosing}
                                    onClose={() => {
                                        if (!preventPanelClosing) {
                                            this.togglePanel(PANEL.PAYMENT);
                                            this.setState({resetFormOnClose: true}, () => {
                                                this.setState({resetFormOnClose: false});
                                            })
                                        }
                                    }}
                                >
                                    <Payment
                                        myAutoPayInfo={myAutoPayInfo}
                                        myAmountsLoader={myAmountsLoader}
                                        myAmounts={myAmounts}
                                        resetFormOnClose={resetFormOnClose}
                                        togglePreventPanelClosing={this.togglePreventPanelClosing}
                                        preventPanelClosing={preventPanelClosing}
                                    />
                                </FlyInRightPanel>
                                {/*}*/}

                                {activePanel === PANEL.INVOICES &&
                                <FlyInRightPanel
                                    title="My Invoices"
                                    isVissible={visiblePanel === PANEL.INVOICES}
                                    onClose={() => this.togglePanel(PANEL.INVOICES)}
                                >
                                    <Invoices
                                        myInvoicesInfoLoader={myInvoicesInfoLoader}
                                        myInvoices={myInvoices}
                                        myAmountsLoader={myAmountsLoader}
                                        myAmounts={myAmounts}
                                    />
                                </FlyInRightPanel>
                                }

                                {activePanel === PANEL.AUTOPAY &&
                                <FlyInRightPanel
                                    title="AutoPay"
                                    isVissible={visiblePanel === PANEL.AUTOPAY}
                                    onClose={() => {
                                        this.togglePanel(PANEL.AUTOPAY);
                                        this.setState({ resetFormOnClose: true }, () => {
                                            this.setState({ resetFormOnClose: false });
                                        })
                                    }}
                                >
                                    <AutoPay
                                        accountInfo={accountInfo}
                                        myAutoPayInfo={myAutoPayInfo}
                                        myAutoPayAvailableCC={myAutoPayAvailableCC}
                                        togglePanel={this.togglePanel}
                                    />
                                </FlyInRightPanel>
                                }

                                {activePanel === PANEL.PAPERLESS &&
                                <FlyInRightPanel
                                    title="Paperless Billing"
                                    isVissible={visiblePanel === PANEL.PAPERLESS}
                                    onClose={() => {
                                        this.togglePanel(PANEL.PAPERLESS);
                                        this.setState({ resetFormOnClose: true }, () => {
                                            this.setState({ resetFormOnClose: false });
                                        })
                                    }}
                                >
                                    <Paperless
                                        myDistributionMethods={myDistributionMethods}
                                        myCurrentDistributionMethod={myCurrentDistributionMethod}
                                    />
                                </FlyInRightPanel>
                                }

                            </>
                        )}

                    </div>
                </div>
            </>
        );
    }
}

export default CustomerServices;
